/*
 * @Author: Hyman Choi
 * @Date: 2021-01-27 11:12:21
 * @LastEditTime: 2021-01-28 15:57:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\api\ultrasonicGroupsMember.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 获取单个超人圈组内成员列表
 *
 * @param {*} params
 */
export function getGroupMemberList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/Member/List',
    method: 'get',
    params
  })
}

/**
 * 获取单个超人圈组内黑名单列表
 *
 * @param {*} params
 */
export function getBlackUserList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/Black/List',
    method: 'get',
    params
  })
}

/**
 * 设置单个超人圈组内成员角色
 *
 * @param {*} data
 */
export function setMemberRole(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroupMember/Role',
    method: 'post',
    data
  })
}

/**
 * 拉黑/恢复单个超人圈组内成员
 *
 * @param {*} data
 */
export function blockMember(data) {
  return request({
    url:
      config.API_ADMIN + '/Api/V1/AdminForums/ForumGroupMember/BlackOrCancel',
    method: 'post',
    data
  })
}

/**
 * 禁言/解禁单个超人圈组内成员
 *
 * @param {*} data
 */
export function forbiddenMember(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroupMember/Forbidden',
    method: 'post',
    data
  })
}

/**
 * 删除单个超人圈组内成员
 *
 * @param {*} params
 */
export function deleteMember(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroupMember/Delete',
    method: 'delete',
    params
  })
}
